// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this files, we write styles for DropZone component
*/

.dropZoneLayer {
  width: 395px;
  width: 20.57vw;
  height: 112px;
  height: 10.37vh;
  background: #ffffff;
  border: 1px dashed #838383;
  border: 0.05vw dashed #838383;
  box-sizing: border-box;
  /* border-radius: 6px; */
  border-radius: 5px;
  border-radius: 0.31vw;
}

.fileupload {
  background-color: blue;
}

.fileuploadparas {
  margin-bottom: 1.5%;
  color: #535353;
  font-weight: var(--header-FontWeight);
  font-size: var(--default-FontSize);
}

.fileuploadbutton {
  width: max-content;
  min-height: 35px;
  background-color: #1f3c88;
  border: 1px solid #1f3c88;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  font-size: var(--label-FontSize);
  margin-bottom: 1%;
}

.dropZoneContainer {
  font-family: SF Pro Display !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  font-size: 0.73vw !important;
  line-height: 18px !important;
  line-height: 1.67vh !important;
  color: #595959 !important;
  flex: none;
  order: 0;
  align-self: flex-start;
  margin: 0px 16px !important;
  margin: 0vw 0.83vw !important;
}

.dropzone {
  text-align: center;
  padding: 20px;
  padding: 1.04vw;
  border: 3px dashed #eeeeee;
  border: 0.16vw dashed #bdc3c7;
  background-color: #ebebeb;
  color: #9b9898;
  border-radius: 4px;
}

.Dropzone_root {
  display: flex;
  justify-content: space-between;
  line-height: 0%;
}

.Dropzone_root:hover p {
  transform: scale(1.1);
}

/* .container {
  margin-bottom: 0.5%;
} */

ul {
  margin-top: 8px;

  margin-bottom: 0px;

  padding: 0px;
}
.fileuploadparas {
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--header-FontWeight);
  color: #545454;
}

.fileuploadbutton:hover {
  cursor: pointer;
}
.headerTemplate_Upload .dropDown_styles .dropDown_styles_Icon {
  padding: 0 10px 0 10px;
}

@media screen and (min-width: 500px) and (max-width: 1000px) {
  .fileuploadparas {
    margin-bottom: 3%;
  }
}

@media screen and (min-width: 300px) and (max-width: 500px) {
  .fileuploadparas {
    margin-bottom: 6%;
  }
}
.custom_fileuploadbutton {
  color: #1f3c88;
  position: absolute;
  margin-left: 14.5%;
  margin-top: 1.25%;
}
.custom_fileuploadbutton:hover {
  cursor: pointer;
}

.imgClass {
  height: 60px;
  width: 100%;
  display: block;
  padding: 0px 37px 4px;
}

.OrgLogo .imgClass {
  height: 65px;
  width: 65px;
  display: block;
  padding: 5px;
}

.headerTemplate_Upload .dropzonearea .OrgLogo {
  display: flex;
  justify-content: center;
}

.LogoContainer {
  /* height: 108px; */
  /* width: 118px; */
  border: 1px solid #b6b6b6;
  border-radius: 8px;
  height: fit-content;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 130px;
}

.LogoViewer {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;
}

.org_field .LogoContainer .LogoViewer {
  height: 100px;
}

.CancelLogo {
  text-align: right;
}
.CancelLogo svg {
  background-color: red;
  color: white;
  border-radius: 50%;
  height: 17px;
  width: 17px;
  cursor: pointer;
}

.footerBasicLogoUpload .dropzonearea .Upload_logo {
  cursor: pointer;
}

.brandingSetupPage .dropDown_styles .dropDown_styles_DropFiles {
  margin-top: -20px;
}

.filetypeheading {
  font-weight: 350;
  font-size: 13px;
  line-height: 22px;
  display: flex;
  flex-direction: column;
}

.dropzonearea .customContent {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/dropZone/DropZone.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;CAEC;;AAED;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,UAAU;EACV,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;GAEG;;AAEH;EACE,eAAe;;EAEf,kBAAkB;;EAElB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/*\n  In this files, we write styles for DropZone component\n*/\n\n.dropZoneLayer {\n  width: 395px;\n  width: 20.57vw;\n  height: 112px;\n  height: 10.37vh;\n  background: #ffffff;\n  border: 1px dashed #838383;\n  border: 0.05vw dashed #838383;\n  box-sizing: border-box;\n  /* border-radius: 6px; */\n  border-radius: 5px;\n  border-radius: 0.31vw;\n}\n\n.fileupload {\n  background-color: blue;\n}\n\n.fileuploadparas {\n  margin-bottom: 1.5%;\n  color: #535353;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--default-FontSize);\n}\n\n.fileuploadbutton {\n  width: max-content;\n  min-height: 35px;\n  background-color: #1f3c88;\n  border: 1px solid #1f3c88;\n  border-radius: 5px;\n  color: white;\n  font-weight: bold;\n  font-size: var(--label-FontSize);\n  margin-bottom: 1%;\n}\n\n.dropZoneContainer {\n  font-family: SF Pro Display !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  font-size: 0.73vw !important;\n  line-height: 18px !important;\n  line-height: 1.67vh !important;\n  color: #595959 !important;\n  flex: none;\n  order: 0;\n  align-self: flex-start;\n  margin: 0px 16px !important;\n  margin: 0vw 0.83vw !important;\n}\n\n.dropzone {\n  text-align: center;\n  padding: 20px;\n  padding: 1.04vw;\n  border: 3px dashed #eeeeee;\n  border: 0.16vw dashed #bdc3c7;\n  background-color: #ebebeb;\n  color: #9b9898;\n  border-radius: 4px;\n}\n\n.Dropzone_root {\n  display: flex;\n  justify-content: space-between;\n  line-height: 0%;\n}\n\n.Dropzone_root:hover p {\n  transform: scale(1.1);\n}\n\n/* .container {\n  margin-bottom: 0.5%;\n} */\n\nul {\n  margin-top: 8px;\n\n  margin-bottom: 0px;\n\n  padding: 0px;\n}\n.fileuploadparas {\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--header-FontWeight);\n  color: #545454;\n}\n\n.fileuploadbutton:hover {\n  cursor: pointer;\n}\n.headerTemplate_Upload .dropDown_styles .dropDown_styles_Icon {\n  padding: 0 10px 0 10px;\n}\n\n@media screen and (min-width: 500px) and (max-width: 1000px) {\n  .fileuploadparas {\n    margin-bottom: 3%;\n  }\n}\n\n@media screen and (min-width: 300px) and (max-width: 500px) {\n  .fileuploadparas {\n    margin-bottom: 6%;\n  }\n}\n.custom_fileuploadbutton {\n  color: #1f3c88;\n  position: absolute;\n  margin-left: 14.5%;\n  margin-top: 1.25%;\n}\n.custom_fileuploadbutton:hover {\n  cursor: pointer;\n}\n\n.imgClass {\n  height: 60px;\n  width: 100%;\n  display: block;\n  padding: 0px 37px 4px;\n}\n\n.OrgLogo .imgClass {\n  height: 65px;\n  width: 65px;\n  display: block;\n  padding: 5px;\n}\n\n.headerTemplate_Upload .dropzonearea .OrgLogo {\n  display: flex;\n  justify-content: center;\n}\n\n.LogoContainer {\n  /* height: 108px; */\n  /* width: 118px; */\n  border: 1px solid #b6b6b6;\n  border-radius: 8px;\n  height: fit-content;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 130px;\n}\n\n.LogoViewer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 5px;\n}\n\n.org_field .LogoContainer .LogoViewer {\n  height: 100px;\n}\n\n.CancelLogo {\n  text-align: right;\n}\n.CancelLogo svg {\n  background-color: red;\n  color: white;\n  border-radius: 50%;\n  height: 17px;\n  width: 17px;\n  cursor: pointer;\n}\n\n.footerBasicLogoUpload .dropzonearea .Upload_logo {\n  cursor: pointer;\n}\n\n.brandingSetupPage .dropDown_styles .dropDown_styles_DropFiles {\n  margin-top: -20px;\n}\n\n.filetypeheading {\n  font-weight: 350;\n  font-size: 13px;\n  line-height: 22px;\n  display: flex;\n  flex-direction: column;\n}\n\n.dropzonearea .customContent {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
